export const catSlug = (c) => c.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
